import styled from "@emotion/styled";
import { fontRoboto } from "@product/scmp-sdk";

import { Loading } from "scmp-app/components/common/loading";
import { EntityLink } from "scmp-app/components/entity-link";

export const StyledLoading = styled(Loading)`
  margin-block: 43px;
  margin-inline: 0;
`;

export const TopicsContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-items: center;

  margin-block-end: 60px;
  padding-block-start: 10px;

  border: 1px solid #e5e5e5;
  border-width: 1px 0;
`;

export const StyledEntityLink = styled(EntityLink)`
  flex-basis: 100%;

  padding-block: 10px;
  padding-inline: 0 24px;
  box-sizing: border-box;

  color: #4585ff;
  font-weight: 700;
  font-size: 13px;
  font-family: ${fontRoboto};
  line-height: 15px;

  ${props => props.theme.breakpoints.only("tablet")} {
    flex-basis: 215px;

    padding-inline-end: 21px;
  }
  ${props => props.theme.breakpoints.up("desktop")} {
    flex-basis: 234px;
  }
`;

export const Container = styled.div``;
